import "./App.css";
import { motion } from "motion/react";
import { message_properties } from "./data";
import zoe from "./images/zoe.gif";

function App() {
  return (
    <div className="App container-fluid">
      <header className="App-header col-md-3 col-sm-12">
        {message_properties.map((item) => (
          <motion.div
            animate={{ opacity: [0, 1] }}
            transition={{ duration: 3, ease: "easeInOut" }}
            className="Birthday-message"
          >
            {item.message.split("").map((l, i) => (
              <motion.span
                style={{ color: item.color }}
                key={i}
                animate={{ y: [0, -15, 0] }}
                transition={{ duration: 1.5, delay: i * 0.1, repeat: Infinity }}
              >
                {l}
              </motion.span>
            ))}
          </motion.div>
        ))}
         <motion.img
          src={zoe}
          alt="Zoe"
          animate={{ opacity: [0, 1] }}
          transition={{ ease: "easeInOut", duration: 3 }}
          className="img-fluid"
        />
      </header>
    </div>
  );
}

export default App;
